import { useSyncExternalStore } from 'react';
import { readJsonPref, writeJsonPref } from '@utils/localJsonPref';

// A personal display preference, kept in this browser like the UI language:
// whether page headers show their title and subtitle. On by default.
const KEY = 'dorca.pageTitles.visible';
// Same-tab listeners: the `storage` event only fires in OTHER tabs.
const CHANGE_EVENT = 'dorca:page-titles-visible';

const read = (): boolean => readJsonPref(KEY) !== false;

function subscribe(notify: () => void): () => void {
  window.addEventListener(CHANGE_EVENT, notify);
  window.addEventListener('storage', notify);
  return () => {
    window.removeEventListener(CHANGE_EVENT, notify);
    window.removeEventListener('storage', notify);
  };
}

/** Whether page headers show their title and subtitle. */
export function usePageTitlesVisible(): boolean {
  return useSyncExternalStore(subscribe, read, () => true);
}

export function setPageTitlesVisible(visible: boolean): void {
  writeJsonPref(KEY, visible);
  window.dispatchEvent(new Event(CHANGE_EVENT));
}
